import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from '@interceptor/auth/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ToastrModule, provideToastr } from 'ngx-toastr';
import { provideHighlightOptions } from 'ngx-highlightjs';
import { VIEWS, View, ListComponent, IconsComponent, DataService, CONFIG, NgeExplorerConfig } from 'filemanager-explorer';
import {ExampleDataService} from '@core/data/data.service';
import {FilemanagerService} from '@services/filemanager/filemanager.service';
import { ENVIRONMENT_CONFIG } from '@projects/web-rtc-communication/src/app/configs/environment.token';
import { environment } from '@environment/environment';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const myExplorerConfig: NgeExplorerConfig = {
  defaultView: 'Icons', // List
  // defaultView: 'List', // Icons
  homeNodeName: 'Home',
  multipleSelection: true,
  homeTreeLink: true,
  showParentInList: true,
  openFileOnDblClick: true,
  features: {
    delete: true,
    upload: true,
    download: true,
    rename: true,
    createDir: true,
    viewFile: true,
    sendFile: true,
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideToastr(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHighlightOptions({
      coreLibraryLoader: () => import('highlight.js/lib/core'),
      lineNumbersLoader: () => import('ngx-highlightjs/line-numbers'),
      languages: {
        typescript: () => import('highlight.js/lib/languages/typescript'),
        css: () => import('highlight.js/lib/languages/css'),
        xml: () => import('highlight.js/lib/languages/xml'),
      },
    }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    importProvidersFrom(
      TablerIconsModule.pick(TablerIcons),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    { provide: DataService, useClass: FilemanagerService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: ENVIRONMENT_CONFIG,
      useValue: environment  // anche parziale: solo le chiavi che vuoi sovrascrivere
    },
    {
      provide: CONFIG,
      useValue: myExplorerConfig
    }
  ]
};
